// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3fVMa","label":"SetPasswdForm_label__13PKZ"};